import $ from 'jquery';
import Lenis from 'lenis'


const init = () => {
  const lenis = new Lenis({
    autoRaf: true,
  });

  $(document).on('click', '.js-scroll', function(e) {
    e.preventDefault();
    const href = $(this).attr('href');
    const delay = $(this).data('delay') ? parseInt($(this).data('delay')) : 0;
    const addPosition = $(this).data('position') ? parseInt($(this).data('position')) : 0;
    setTimeout(() => {
      const target = $(href);
      const position = target.offset().top;
      const shift = window.innerWidth < 992 ? 100 : 160 + addPosition;

      lenis.scrollTo(position - shift);
    }, delay);
  });
}

export {
  init
}